/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantsUpdateResponseDto = {
  /**
   * Unique identifier of the tenant.
   */
  id: number;
  /**
   * Name of the tenant.
   */
  name: string;
  /**
   * Tenant registration number.
   */
  registrationNumber?: string;
  /**
   * Tenant contact email.
   */
  email?: string;
  /**
   * Date and time when the tenant was created.
   */
  createdAt: string;
  /**
   * Date and time when the tenant was last activated.
   */
  lastActivatedAt: string;
  /**
   * Date and time when the tenant was last suspended.
   */
  lastSuspendedAt?: string;
  /**
   * Date and time when the tenant was last deactivated.
   */
  lastDeactivatedAt?: string;
  /**
   * Current status of the tenant.
   */
  status: TenantsUpdateResponseDto.status;
  /**
   * Default locale for the tenant users.
   */
  userLocale: TenantsUpdateResponseDto.userLocale;
  /**
   * Default locale for the tenant clients.
   */
  clientLocale: TenantsUpdateResponseDto.clientLocale;
  /**
   * Updated status of the device.
   */
  targetStatus: TenantsUpdateResponseDto.targetStatus;
};
export namespace TenantsUpdateResponseDto {
  /**
   * Current status of the tenant.
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
  }
  /**
   * Default locale for the tenant users.
   */
  export enum userLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  /**
   * Default locale for the tenant clients.
   */
  export enum clientLocale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  /**
   * Updated status of the device.
   */
  export enum targetStatus {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
  }
}

